<template>
  <div class="snackbar snackbar--vsb">
    <div
      v-for="(item,k) in snackBars"
      class="snackbar__msg vsb"
      :id="'snack-'+item.id"
      :class="['snackbar__msg--'+item.type, {'snackbar__msg--withactions': item.action}]"
      :key="'snack-'+item.id"
      @click.self="deleteItem(k)"
    >
      <div class="snackbar-header">
        <span
          class="timerbar"
          :style="{animationDuration: (item.timeout)+'s'}"
        ></span>
        <div
          class="snackbar--close-button"
          @click="deleteItem(k)"
        >&times;</div>
      </div>
      <div class="snackbar-body p-1">
        <span>{{item.message}}</span>
      </div>
      <div
        class="actions mx-auto"
        v-if="item.type === 'error'"
      >
        <button
          class="Fuell-Button small blue px-4"
          @click="openSupport(item)"
        > <span class="Fuell-Button--label">{{$t('snackbar_launch_intercom_message')}}</span></button>
      </div>
      <div
        class="actions mx-auto"
        v-if="item.type === 'success_onboarding'"
      >
        <div class="d-flex justify-content-center">
          <a
            class="d-flex h-100"
            rel="noopener noreferrer"
            target="_blank"
            style="margin-top:10px"
            href="https://apps.apple.com/us/app/fuell/id1502092784?itsct=apps_box&itscg=30200"
          >
            <img
              :src="require('@/assets/img/apple-store-badge.svg')"
              alt="Download on the App Store"
              class="align-self-center"
            ></a>
          <a
            rel="noopener noreferrer"
            class="d-flex  h-100"
            target="_blank"
            href='https://play.google.com/store/apps/details?id=com.fuell&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
          >
            <img
              alt='Get it on Google Play'
              :src="require('@/assets/img/google-play-badge.svg')"
            /></a>
        </div>

      </div>
      <div
        class="actions mx-auto"
        v-if="item.type==='network_error'"
      >
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'SnackBars',
  computed: {
    snackBars () {
      return this.$store.getters['SnackBars/items']
    }
  },
  data () {
    return {
      data: ''
    }
  },
  methods: {
    deleteItem (v) {
      this.$store.dispatch('SnackBars/removeItem', v)
    },
    async openSupport (notification) {
      this.notification = notification
      const defaultMessage = this.$route && this.$route.path ? this.$t('intercom_predefined_error_message_with_route', { errorMessage: this.notification.message, routerUrl: this.$route.path }) : this.$t('intercom_predefined_error_message', { errorMessage: this.notification.message })
      if (window.HubSpotConversations?.widget?.open) {
        window.HubSpotConversations.widget.open(defaultMessage)
      }
    },
    reload () {
      location.reload()
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.dispatch('SnackBars/clearItems')
  }
}
</script>
<style lang="scss" scoped>
.Fuell-Button--label {
  font-size: 1.1em;
  @media screen and (max-width: 576px) {
    font-size: 0.9em;
  }
}

.snackbar__msg {
  cursor: pointer;
}

.actions {
  margin-top: 0.5em;
  margin-left: 10%;
  display: flex;
  justify-content: center;
}

.snackbar__msg--withactions {
  min-width: 40vw;
}

.snackbar__msg .timerbar {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 1px;
  width: 100%;
  background-color: var(--text-body);
  animation-name: timerbar;
  animation-duration: inherit;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

.snackbar__msg--info .timerbar {
  background: var(--semantic-brand-main);
}

@keyframes timerbar {
  0% {
    width: 100%;
  }
  100% {
    width: 0;
  }
}
</style>
